//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/Builder.js";
import "../no/SelectDisplayableObjectList.js";
import "../Annotations/Annotations.BoundaryBuilder.js";
import "../Annotations/Annotations.HatchFillSettingsBuilder.js";
import "../no/SelectObjectList.js";
let d=[[[0,"Angle",1,1],[1,"AnnotationToExclude",0,"SelectDisplayableObjectList",0],[0,"AnnotationType",1,0],[0,"AreafillAngle",1,1],[0,"AutomaticallyExcludeText",1,0],[1,"Boundary",0,"Annotations.BoundaryBuilder",0],[0,"Color",1,1],[0,"CrosshatchFile",1,1],[0,"Distance",1,1],[1,"HatchFillSettings",0,"Annotations.HatchFillSettingsBuilder",0],[0,"Material",1,1],[0,"Pattern",1,1],[0,"Scale",1,1],[0,"Tolerance",1,1],[0,"Width",1,1]],[[["annotation"],"GetMarginPercent",{R_:{marginpercent:''}},1,0],[["annotation","marginpercent"],"SetMarginPercent",{},2,0],[["numCurrentDirectionMapElement"],"SetNumCurrentDirectionMapElements",{},1,0],[["curveTag","curveDirection"],"SetCurveDirection",{},2,0],[["section","curve","curveDirections"],"SetSectionCurveDirections",{},3,0]],[]];
SPLM.Annotations.HatchBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.HatchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.HatchBuilder.AnnotationTypes = Object.freeze({
    "Crosshatch" : "Crosshatch", "AreaFill" : "AreaFill"});

export default SPLM;